import { Technician } from 'types';
import { baseQuery } from '../baseQuery';

export const putTechnician = async (payload: Partial<Technician>) => {
  const { data } = await baseQuery(`technicians/${payload.ID}`, {
    type: 'PUT',
    body: {
      ...payload,
    },
  });

  return data;
};
